module.exports = __webpack_public_path__ + "img/r-221.bb0f31f7.jpg";